module.exports = __webpack_public_path__ + "img/hpsc.917621b0.jpg";